<div class="detail-wrapper">
  <div class="d-flex w-100 h-100">
    <ng-content></ng-content>
  </div>
</div>

